import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
// import "../../../css/EnterpriseDetails.css";
import "../../../css/DocumentHistoryResponsive.css";
import changeStatusIcon from "../../../assets/UserIcons/ChangeStatusIconBlack.svg";
import deleteIcon from "../../../assets/UserIcons/DeleteIcon.svg";
import { getFilteredDocs } from "../../../utils/approvedContentTabs";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../../utils/toastMessages";
import { formatFileType } from "../../../utils/FileType";
import folderIcon from "../../../assets/Images/folder.png";
import pluseIcon from "../../../assets/UserIcons/PlusIcon.svg";
import crossIcon from "../../../assets/UserIcons/crossIcon.svg";
import revertIcon from "../../../assets/UserIcons/ChangeStatusIconBlack.svg";
import { formatDateToUserTimeZone } from "../../../utils/formatDate";
import { useTableSort } from "../../../hooks/useTableSort";
import { SortableHeader } from "../../../components/SortableHeader";
import warningIcon from "../../../assets/UserIcons/FileIcon.svg";

const UploadedDocsFiles = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [allApprovedDocs, setAllApprovedDocs] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRevertModal, setShowRevertModal] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [deleteHandler, setDeleteHandler] = useState(null);
  const [revertHandler, setRevertHandler] = useState(null);
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  const fileInputRef = useRef(null);

  const [stats, setStats] = useState({
    user_files_active_count: 0,
    user_files_inactive_count: 0,
    uploaded_files_active_count: 0,
    uploaded_files_inactive_count: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  // ✅ Fetch stats
  const fetchStats = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("access_token");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/files/stats`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStats(data.data || {});
      } else {
        // showErrorToast(data.message || "Failed to load document stats");
      }
    } catch (error) {
      console.error("❌ Error fetching stats:", error);
      showErrorToast("Something went wrong while fetching stats");
    } finally {
      setIsLoading(false);
    }
  };

  // Open file chooser
  const handleBoxClick = (item) => {
    if (item.isAddNew && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Corrected file upload function for multiple files
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newFiles = files.map((file) => ({ file, status: "uploading" }));
    setAttachedFiles((prev) => [...prev, ...newFiles]);

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      const formData = new FormData();
      files.forEach((file) => formData.append("files", file));

      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/files/upload-multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Check for duplicates returned by API
      if (res.data.status === "duplicate" && res.data.duplicates?.length > 0) {
        setDuplicateFiles(res.data.duplicates); // set duplicate files state
        setShowDuplicateModal(true); // show modal
      } else {
        // Update status for successfully uploaded files
        const uploadedFileNames = res.data.uploaded_files.map(
          (f) => f.user_files_name
        );
        setAttachedFiles((prev) =>
          prev.map((f) =>
            uploadedFileNames.includes(f.file.name)
              ? { ...f, status: "done" }
              : f
          )
        );
        showSuccessToast("Files uploaded successfully");
        fetchGlobalUserDocs();
      }
    } catch (error) {
      console.error("Upload failed:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Server failed, please try again later.";

      setAttachedFiles((prev) =>
        prev.map((f) =>
          files.some((file) => file.name === f.file.name)
            ? { ...f, status: "error" }
            : f
        )
      );

      showErrorToast(`File upload failed: ${errorMsg}`);
    }

    e.target.value = "";
  };

  const handleDuplicateYes = async () => {
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/files/allow-duplicate`, // API for cloning duplicates
        { duplicates: duplicateFiles },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      showSuccessToast(
        `${res.data.count} duplicate files uploaded successfully`
      );
      fetchGlobalUserDocs();

      // Close modal and reset
      setShowDuplicateModal(false);
      setDuplicateFiles([]);
    } catch (err) {
      console.error("Duplicate upload failed:", err);
      showErrorToast("Failed to upload duplicate files");
    }
  };

  const statsData = [
    {
      label: "New",
      icon: pluseIcon,
      isAddNew: true,
    },
    // {
    //   label: "Uploaded Documents",
    //   icon: folderIcon,
    //   count:  getFilteredDocs(allApprovedDocs1, "document").length,
    // },
    {
      label: "Saved Documents",
      icon: folderIcon,
      count: stats.user_files_active_count,
    },
    {
      label: "Deleted Documents",
      icon: folderIcon,
      count: stats.user_files_inactive_count || 0,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname;

  const tabs = [
    // { name: "Recently", path: "/user/mydrive-recent" },
    // { name: "Uploaded", path: "/user/mydrive-docs" },
    { name: "Saved", path: "/user/knowledgespace-saved" },
    { name: "Deleted", path: "/user/knowledgespace-deleted" },
    // { name: "Q&A", path: "/user/qahistory" },
  ];

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchGlobalUserDocs = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/files/inactive-files`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // ✅ Extract inactive files
      const inactiveFiles = res.data?.data?.files || [];

      // console.log("Inactive files:", inactiveFiles);
      setAllApprovedDocs(inactiveFiles);
    } catch (error) {
      console.error("❌ Error fetching inactive user docs:", error);
      showErrorToast(TOAST_MESSAGES.DOCUMENT_HISTORY.FETCH_FAILED);
    }
  };

  useEffect(() => {
    fetchGlobalUserDocs();
    fetchStats();
  }, []);

  const handleDownload = async (pythonFileUUID) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/download?python_file_uuid=${pythonFileUUID}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errText = await response.text();
        throw new Error(`Failed: ${errText}`);
      }

      const blob = await response.blob();

      // ✅ Get filename from Content-Disposition header
      let filename = "downloaded_file";
      const contentDisposition = response.headers.get("Content-Disposition");
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
        );
        if (match && match[1]) filename = decodeURIComponent(match[1]);
      }

      // ✅ Trigger download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Download failed:", error);
      showErrorToast("Failed to download file.");
    }
  };

  //  Delete API Function
  const handleDeleteDocument = async (fileId) => {
    setIsDeleting(true);

    try {
      await api.delete(
        `${process.env.REACT_APP_API_URL}/files/delete/${fileId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // showSuccessToast("Document deleted successfully");
      await fetchGlobalUserDocs(); // refresh document list
      fetchStats();
      setShowDeleteModal(false);
    } catch (error) {
      console.error("❌ Error deleting document:", error);
      showErrorToast("Failed to delete document");
    } finally {
      setIsDeleting(false);
      setDeleteHandler(null);
    }
  };

  // 🌀 Revert Delete (restore)
  const handleRevertDocument = async (fileId) => {
    setIsDeleting(true);

    try {
      await api.put(
        `${process.env.REACT_APP_API_URL}/files/revert/${fileId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setShowRevertModal(false);

      showSuccessToast("Document restored successfully");

      await fetchGlobalUserDocs();
      fetchStats();
    } catch (error) {
      console.error("❌ Error restoring document:", error);
      showErrorToast("Failed to restore document");
    } finally {
      setIsDeleting(false);
      setDeleteHandler(null);
    }
  };

  const documentFiles = getFilteredDocs(allApprovedDocs, "document");
  const filteredFiles = allApprovedDocs
    .filter((file) =>
      file.user_files_name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((file) => {
      if (!dayFilter) return true;

      const updatedDate = new Date(file.updated_timestamp);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (dayFilter === "Today") return updatedDate >= today;

      if (dayFilter === "Yesterday") {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return updatedDate >= yesterday && updatedDate < today;
      }

      return true;
    })
    .sort((a, b) => {
      const dateA = new Date(a.updated_timestamp);
      const dateB = new Date(b.updated_timestamp);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

  const totalEntries = filteredFiles.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredFiles.slice(indexOfFirst, indexOfLast);
  const showingFrom = totalEntries === 0 ? 0 : indexOfFirst + 1;
  const showingTo = Math.min(indexOfLast, totalEntries);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageClick = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleReset = () => {
    setSortOrder("desc");
    setDayFilter("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };
  const { sortedData, requestSort, sortConfig } = useTableSort(currentData);

  return (
    <div className="mx-2 pt-1 h-100">
      <div className="d-flex flex-wrap gap-3 mb-0 justify-content-evenly align-items-stretch">
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          multiple
          accept=".pdf,.docx,.txt,.doc,.pptx,.xlsx,.mp3,.wav,.aac,.flac,.mp4,.mov,.avi,.mkv,.flv,.png,.jpg,.jpeg,.gif,.bmp,.tiff"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        {statsData.map((item, index) => (
          <div
            key={index}
            className={`dashboard-box p-3 rounded shadow-sm d-flex flex-column  ${
              item.isAddNew ? "AddNew" : ""
            }`}
            style={{
              cursor: item.isAddNew ? "pointer" : "default",
              transition: "0.2s ease",
              width: "230px",
              minHeight: "120px",
            }}
            onClick={() => handleBoxClick(item)}
          >
            {/* Top Section */}
            <div
              style={{
                flexDirection: item.isAddNew ? "column" : "row",
                gap: item.isAddNew ? "19px" : "8px",
              }}
              className={`d-flex align-items-${
                item.isAddNew ? "start" : "center"
              } ${item.isAddNew ? "" : ""}`}
            >
              {item.icon && (
                <img
                  className="icon-image"
                  src={item.icon}
                  alt={item.label}
                  style={{ width: "18px", height: "18px" }}
                />
              )}
              <h6 className="mb-0">{item.label}</h6>
            </div>

            {/* Bottom Section (count for non-AddNew) */}
            {!item.isAddNew ? (
              <div
                className="d-flex  w-100 mt-2 refresh-prompts"
                style={{ fontWeight: "600", fontSize: "16px" }}
              >
                {isLoading ? "0" : item.count ?? 0}
              </div>
            ) : (
              <div className="box-summary">
                <span className="invisible">placeholder</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="d-flex refresh-prompts justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold" style={{ fontSize: "20px" }}>
          Deleted Documents
        </span>
      </div>

      {/* <div className="mb-3 mt-3 tabs-wrapper">
        <div className="d-flex p-2 rounded border tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button ${
                currentTab === tab.path ? "active" : ""
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div> */}
      <div className="mt-3 tabs-wrapper ">
        <div className="tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button ${
                currentTab === tab.path ? "active" : " "
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      <div
        style={{ borderLeft: "1px solid var(--dark-color) " }}
        className="d-flex px-2 py-1 justify-content-between align-items-center "
      >
        <div className="d-flex align-items-center">
          <select
            className="form-select w-auto"
            value={entriesPerPage}
            onChange={handleEntriesChange}
          >
            {[50, 100, 500].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <label className="ms-2 mt-2">Entries per page</label>
        </div>

        {/* Search input */}
        <div className="search">
          <div
            className="input-group custom-search-group"
            style={{ width: "320px" }}
          >
            <span className="input-group-text">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
      </div>

      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="text-muted fs-5 profile-i">
            There are no deleted document(s) in this section.
          </p>
        </div>
      ) : (
        <div
          className="not-disable"
          style={{ borderLeft: "1px solid var(--dark-color) " }}
        >
          <div className="table-responsive">
            <table className="table DocHistory-table table-sm w-100">
              <thead className="text-left">
                <tr>
                  <SortableHeader
                    column="user_files_name"
                    label="Name"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="file_extension"
                    label="Type"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="file_size"
                    label="Size"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="created_timestamp"
                    label="Uploaded On"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="updated_timestamp"
                    label="Last Updated On"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((file, index) => (
                    <tr key={file.user_files_id || index}>
                      <td
                        data-label="Document Name"
                        className="text-truncate text-left"
                        style={{ maxWidth: "150px" }}
                        title={file.user_files_name}
                      >
                        {file.user_files_name.replace(/\.[^/.]+$/, "")}
                      </td>

                      <td data-label="Document Type" className="text-left">
                        {formatFileType(file.file_type, file.user_files_name)}
                      </td>

                      <td className="text-left" data-label="Document Size">
                        {formatFileSize(file.file_size)}
                      </td>
                      {/* <td>
                        {(file.uploaded_by || "User").charAt(0).toUpperCase() +
                          (file.uploaded_by || "User").slice(1)}
                      </td> */}
                      <td data-label="First Created" className="text-left">
                        {/* {new Date(file.created_timestamp).toLocaleString()} */}
                        {formatDateToUserTimeZone(file.created_timestamp)}
                      </td>
                      <td data-label="Last Updated" className="text-left">
                        {/* {new Date(file.updated_timestamp).toLocaleString()} */}
                        {formatDateToUserTimeZone(file.updated_timestamp)}
                      </td>

                      <td className="text-center">
                        <button
                          className="icon-button"
                          title="Revert File"
                          onClick={() => {
                            setSelectedFileId(file.user_files_id);
                            setRevertHandler(
                              () => () =>
                                handleRevertDocument(file.user_files_id)
                            );
                            setShowRevertModal(true);
                          }}
                        >
                          <img
                            className="icon-image"
                            src={revertIcon}
                            alt="Revert"
                          />
                        </button>

                        <button
                          className="icon-button"
                          title="Delete"
                          onClick={() => {
                            setDeleteHandler(
                              () => () =>
                                handleDeleteDocument(file.user_files_id)
                            );
                            setShowDeleteModal(true);
                          }}
                        >
                          <img
                            className="icon-image"
                            src={deleteIcon}
                            alt="Delete"
                          />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No inactive files found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="table-footer bgcolor fixed-bottom-footer d-flex justify-content-between align-items-center">
            <div className="refresh-prompts">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <ul className="pagination mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(1)}
                >
                  <i className="bi bi-chevron-double-left" />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left" />
                </button>
              </li>
              {pageNumbers.map((num) => (
                <li
                  key={num}
                  className={`page-item ${currentPage === num ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(num)}
                  >
                    {num}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(totalPages)}
                >
                  <i className="bi bi-chevron-double-right" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content position-relative">
              {/* ❌ Close Button */}
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  if (!isDeleting) {
                    setShowDeleteModal(false);
                    setDeleteHandler(null);
                  }
                }}
                aria-label="Close"
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              {/* 🧠 Modal Body */}
              <div className="text-center p-3">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={deleteIcon} // ← your train icon import
                    alt="Training"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>

                <p className="fw-bold mt-3 mb-3 refresh-prompts">
                  Are you sure you want to delete this document permanently?{" "}
                  <br />
                </p>
              </div>

              {/* ⚙️ Modal Footer */}
              <div className="modal-footer justify-content-center gap-2">
                <button
                  type="button"
                  disabled={isDeleting}
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    if (!isDeleting) {
                      setShowDeleteModal(false);
                      setDeleteHandler(null);
                    }
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  disabled={isDeleting}
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={async () => {
                    try {
                      if (deleteHandler) await deleteHandler();
                    } catch (err) {
                      showErrorToast("Something went wrong during deletion");
                    }
                  }}
                >
                  {isDeleting ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showRevertModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content position-relative">
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  if (!isDeleting) {
                    setShowRevertModal(false);
                    setRevertHandler(null);
                  }
                }}
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              <div className="text-center p-3">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={changeStatusIcon} // ← your train icon import
                    alt="Training"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
                <p className="fw-bold mt-3 mb-3 refresh-prompts">
                  Do you want to restore this document?
                </p>
              </div>

              <div className="modal-footer justify-content-center gap-2">
                <button
                  type="button"
                  disabled={isDeleting}
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    if (!isDeleting) {
                      setShowRevertModal(false);
                      setRevertHandler(null);
                    }
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  disabled={isDeleting}
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={async () => {
                    try {
                      if (revertHandler) await revertHandler();
                      setShowRevertModal(false);
                    } catch {
                      showErrorToast("Error restoring document");
                    } finally {
                      setIsDeleting(false);
                    }
                  }}
                >
                  {isDeleting ? "Restoring..." : "Yes, Restore"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDuplicateModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content w-50 position-relative">
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  setShowDuplicateModal(false);
                  setDuplicateFiles([]);
                }}
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              <div className="text-center p-3">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={warningIcon}
                    alt="Duplicate Files"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>

                <p className="fw-bold mt-3 mb-3 refresh-prompts">
                  Duplicate files detected. Do you want to upload anyway?
                </p>

                <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                  {duplicateFiles.map((f) => (
                    <p key={f.file_hash} className="mb-1">
                      📄 <b>{f.originalname}</b> ({Math.round(f.size / 1024)}{" "}
                      KB)
                    </p>
                  ))}
                </div>
              </div>

              <div className="modal-footer justify-content-center gap-2">
                <button
                  type="button"
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    setShowDuplicateModal(false);
                    setDuplicateFiles([]);
                    showErrorToast("Upload cancelled");
                  }}
                >
                  No
                </button>

                <button
                  type="button"
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={handleDuplicateYes}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadedDocsFiles;
